// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page {
    padding-top: 180px;
    background-color: var(--bg-white);
}

.privacy-page-content h1 {
    font-size: var(--font-size-xxxlarge);
    font-weight: var(--font-bold);
    color: var(--text-primary);
    margin-bottom: 0px;
    font-family: var(--font-codec-cold);
    line-height: 1.3;
    text-align: center;
}

.legal-text p {
    font-size: var(--font-size-xsmall);
    font-weight: var(--font-medium);
    color: #494949;
}

.legal-text .legal-bold {
    font-weight: var(--font-bold);
}

.legal-text h3 {
    font-size: var(--font-size-large);
    font-weight: var(--font-bold);
    color: var(--text-black);
    margin-bottom: 13px;
}

.legal-text ul li {
    font-size: var(--font-size-xsmall);
    font-weight: var(--font-medium);
    color: #494949;
    line-height: 1.8;
}

.legal-text h6 {
    font-size: var(--font-size-xsmall);
    font-weight: var(--font-bold);
    color: var(--text-gray-dark);
}

.privacy-page-content-2 {
    padding-bottom: 100px;
}

.page-header-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 15px;
}

.back-btn-container {
    position: absolute;
    left: 15px;
}

@media (min-width: 768px) and (max-width: 1024px) {
    .privacy-page-content h1 {
        font-size: var(--font-size-xxlarge);
        padding-bottom: 20px;
    }

    .legal-text p {
        font-size: var(--font-size-small);
    }

    .legal-text h3 {
        font-size: var(--font-size-xsmall);
    }

    .legal-text ul li {
        font-size: var(--font-size-small);
    }
}

@media (max-width: 767px) {
    .privacy-page {
        padding-top: 82px;
    }

    .page-header-container {
        margin-bottom: 1px !important;
    }

    .privacy-page-content h1 {
        font-size: var(--font-size-medium);
        margin-bottom: 0px;
        text-align: left;
        width: 100%;
        padding: 0 8px;
    }

    .page-header-container {
        flex-direction: column;
        align-items: flex-start;
    }

    .back-btn-container {
        position: static;
        margin-bottom: 15px;
        margin-left: 8px;
    }

    .legal-text p {
        font-size: var(--font-size-small);
    }

    .legal-text h3 {
        font-size: var(--font-size-xsmall);
        line-height: 1.4;
    }

    .legal-text ul li {
        font-size: var(--font-size-small);
    }

    .privacy-page-content-2 {
        padding: 10px 20px 40px 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/PrivacyPage/PrivacyPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI;QACI,mCAAmC;QACnC,oBAAoB;IACxB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,kCAAkC;QAClC,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,kCAAkC;QAClC,gBAAgB;IACpB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".privacy-page {\n    padding-top: 180px;\n    background-color: var(--bg-white);\n}\n\n.privacy-page-content h1 {\n    font-size: var(--font-size-xxxlarge);\n    font-weight: var(--font-bold);\n    color: var(--text-primary);\n    margin-bottom: 0px;\n    font-family: var(--font-codec-cold);\n    line-height: 1.3;\n    text-align: center;\n}\n\n.legal-text p {\n    font-size: var(--font-size-xsmall);\n    font-weight: var(--font-medium);\n    color: #494949;\n}\n\n.legal-text .legal-bold {\n    font-weight: var(--font-bold);\n}\n\n.legal-text h3 {\n    font-size: var(--font-size-large);\n    font-weight: var(--font-bold);\n    color: var(--text-black);\n    margin-bottom: 13px;\n}\n\n.legal-text ul li {\n    font-size: var(--font-size-xsmall);\n    font-weight: var(--font-medium);\n    color: #494949;\n    line-height: 1.8;\n}\n\n.legal-text h6 {\n    font-size: var(--font-size-xsmall);\n    font-weight: var(--font-bold);\n    color: var(--text-gray-dark);\n}\n\n.privacy-page-content-2 {\n    padding-bottom: 100px;\n}\n\n.page-header-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    margin-bottom: 15px;\n}\n\n.back-btn-container {\n    position: absolute;\n    left: 15px;\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n    .privacy-page-content h1 {\n        font-size: var(--font-size-xxlarge);\n        padding-bottom: 20px;\n    }\n\n    .legal-text p {\n        font-size: var(--font-size-small);\n    }\n\n    .legal-text h3 {\n        font-size: var(--font-size-xsmall);\n    }\n\n    .legal-text ul li {\n        font-size: var(--font-size-small);\n    }\n}\n\n@media (max-width: 767px) {\n    .privacy-page {\n        padding-top: 82px;\n    }\n\n    .page-header-container {\n        margin-bottom: 1px !important;\n    }\n\n    .privacy-page-content h1 {\n        font-size: var(--font-size-medium);\n        margin-bottom: 0px;\n        text-align: left;\n        width: 100%;\n        padding: 0 8px;\n    }\n\n    .page-header-container {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .back-btn-container {\n        position: static;\n        margin-bottom: 15px;\n        margin-left: 8px;\n    }\n\n    .legal-text p {\n        font-size: var(--font-size-small);\n    }\n\n    .legal-text h3 {\n        font-size: var(--font-size-xsmall);\n        line-height: 1.4;\n    }\n\n    .legal-text ul li {\n        font-size: var(--font-size-small);\n    }\n\n    .privacy-page-content-2 {\n        padding: 10px 20px 40px 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
